import React, { useState, useEffect, useRef } from 'react';

// Multi-select dropdown of app pages (list comes from GET /api/pages).
// Used by the invite modal and the per-user page-access editor.
function PageAccessSelect({ pages, value, onChange, disabled }) {
  const [open, setOpen] = useState(false);
  const rootRef = useRef(null);
  const selected = value || [];

  // Close when clicking anywhere outside the control. 'click', not
  // 'mousedown': collapsing the menu on mousedown shifts the modal layout, so
  // a click on Save/Send underneath would land on the overlay instead.
  useEffect(() => {
    if (!open) return undefined;
    const onDocClick = (e) => {
      if (rootRef.current && !rootRef.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener('click', onDocClick);
    return () => document.removeEventListener('click', onDocClick);
  }, [open]);

  const toggle = (key) => {
    onChange(selected.includes(key)
      ? selected.filter(k => k !== key)
      : pages.filter(p => p.key === key || selected.includes(p.key)).map(p => p.key));
  };

  const labels = pages.filter(p => selected.includes(p.key)).map(p => p.label);
  const summary = labels.length === 0
    ? 'No pages selected (Dashboard only)'
    : labels.length === pages.length
      ? 'All pages'
      : labels.join(', ');

  return (
    <div className="page-access" ref={rootRef}>
      <button
        type="button"
        className={'page-access-trigger' + (open ? ' open' : '')}
        onClick={() => setOpen(v => !v)}
        disabled={disabled}
        aria-haspopup="listbox"
        aria-expanded={open}
      >
        <span className="page-access-summary">{summary}</span>
        <span className="page-access-count">{labels.length}/{pages.length}</span>
      </button>

      {open && (
        <div className="page-access-menu" role="listbox" aria-multiselectable="true">
          <div className="page-access-tools">
            <button type="button" onClick={() => onChange(pages.map(p => p.key))}>Select all</button>
            <button type="button" onClick={() => onChange([])}>Clear</button>
          </div>
          {pages.map(p => (
            <label key={p.key} className="page-access-option">
              <input
                type="checkbox"
                checked={selected.includes(p.key)}
                onChange={() => toggle(p.key)}
              />
              <span>{p.label}</span>
              <code>{p.route}</code>
            </label>
          ))}
        </div>
      )}
    </div>
  );
}

export default PageAccessSelect;
